import { assign } from '../common/utils';

const initialState = {
    cardInfo: {},
    certInfo: [],
    cardNum: 0,
    selectCertificateMap: []
};

const movieCard = (state = initialState, action) => {
    switch (action.type) {
        case 'card_info_change': //  卡详情页需要
            return assign(state, {
                cardInfo: action.cardInfo
            });
        case 'cert_info_change': //  选择的卡，提单需要
            return assign(state, {
                certInfo: action.certInfo
            });
        case 'cert_num_change': //  选择的卡，提单需要
            return assign(state, {
                cardNum: action.cardNum
            });
        case 'select_certificate_map': //  优惠相关信息
            return assign(state, {
                selectCertificateMap: action.selectCertificateMap
            });
    
    
        default:
            return state;
    }
};

export default movieCard;
